<!-- Experience Preview Container -->
<div class="experience-preview-container">
  <!-- Zoom Info Overlay -->
  <div class="zoom-info-overlay">
    <div class="zoom-percentage">{{ previewZoom() }}%</div>
    <button mat-mini-fab
            (click)="toggleCameraLock()"
            [matTooltip]="isControlsLocked() ? 'Unlock Camera (Enable Mouse Control)' : 'Lock Camera (Enable Game Interaction)'"
            class="control-btn fit-to-view-btn"
            [class.locked]="isControlsLocked()">
      <mat-icon>{{ isControlsLocked() ? 'lock' : 'lock_open' }}</mat-icon>
    </button>
  </div>

  <!-- Game Engine (3D Scene) -->
  <lib-game-engine
    [gameTypeId]="gameTypeId"
    [config]="config"
    [getPrizeIndex]="getPrizeIndex()"
    [enableCameraControls]="!enableAR"
    [enableAR]="enableAR"
    [arMarkerPattern]="arMarkerPattern"
    [arOptions]="arOptions"
    [ctaButton]="ctaButtonConfig()"
    [initialCameraPosition]="initialCameraPosition()"
    [previewMode]="true"
    (gameReady)="onGameReady($event)"
    (gameStart)="onGameStart($event)"
    (gameComplete)="onGameComplete($event)"
    (gameError)="onGameError($event)">
  </lib-game-engine>
</div>
